import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Environment } from '../../../environment';
import { Hatchery, GetHatcheriesResponse } from '../models/hatchery-service.model';

@Injectable({
  providedIn: 'root',
})
export class HatcheryService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.API_BASE_URL}/service/hatchery/secure`;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  public getHatcheries(): Observable<Hatchery[] | HttpErrorResponse> {
    return this.http.get<GetHatcheriesResponse>(`${this.baseUrl}/hatchery?animalType=Broiler`).pipe(
      map((d) => d.hatcheries),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<Hatchery[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }
}
